import React from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import { useAppStore } from '../store/store'

export const RequireAuth = ({ children }: { children: React.ReactNode }) => {
  const token = useAppStore((s) => s.auth?.token)
  const loc = useLocation()
  if (!token) return <Navigate to="/auth/login" replace state={{ from: loc.pathname }} />
  return <>{children}</>
}

export const RequireAnyPermission = ({
  children,
  any
}: {
  children: React.ReactNode
  any?: readonly string[]
}) => {
  const permissions = useAppStore((s) => s.auth?.permissions || [])
  const ok = !any || any.length === 0 || any.some((p) => permissions.includes(p))
  if (!ok) return <Navigate to="/401" replace />
  return <>{children}</>
}
